export default __webpack_public_path__ + "static/ARTE-1-ef4cfed91f8066961f7435fa7654e9e0.jpg";